import { render } from "./Rules.vue?vue&type=template&id=f94585c8"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
script.render = render

export default script